import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorProjectBusinessRoute: InvariantJiraRoute = {
	name: 'issue-navigator-core',
	// Remove the issueKey path param when cleaning up slv-4_migrate_nin_selected_issue_route
	path: '/jira/core/projects/:projectKey/issues/:issueKey?',
	query: ['selectedIssue?'],
};
